<div *ngIf="isLoaded" class="main-container">
    <div class="rejection-details" *ngIf="taskStatus && ['Rejected'].includes(taskStatus)">
        <app-rejection-details [supplierCode]='supplierCode' [rejectionDetails]='rejectionDetails'></app-rejection-details>
    </div>
    <tsl-alert *ngIf="contextVerbiage" icon="info_blue" style="color: #3E6AE1" status="primary">{{
    translate.get(contextVerbiage.insurance.description) }}
    </tsl-alert>
    <div class="header-container">
        <div class="header-description-container">
            <ul>
                <li i18n="@@insuranceSectionHelpContent" t="insuranceSectionHelpContent">Please review and complete or upload your organization's Certificate of Insurance. Ensure to select the policy or coverage type/s and their expiration date before submission. For any questions on the requested documents, please reach out to your Tesla business contact or Global Supply Manager.</li>
            </ul>
        </div>
    </div>
    <div class="table-container">
        <table class="documents" mat-table [dataSource]="dataSource" >
            <ng-container matColumnDef="policyType">
                <th class="table-header-container" mat-header-cell *matHeaderCellDef>
                    <div class="table-header" i18n="@@Policy/CoverageType" t="Policy/CoverageType">Policy/Coverage Type</div>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <div class="policy-type-container">
                        <ng-container *ngFor="let coverage of element.coverages; let j = index">
                            <div class="policy-type-input-container">
                                <tsl-select [disabled]="mode == 'view'"  contentWidth="content" shape="rectangle" 
                                    (selectionChange)="onCoverageTypeChange($event, coverage, j, element)" [value]="coverage.coverageType">
                                    <tsl-option *ngFor="let type of getDocumentOptionList(coverage)"
                                    [value]="type.displayName">
                                    {{ translate.get(type.displayName) }}
                                    </tsl-option>
                                </tsl-select>
                                <input class="policy-type-comment-input" tslInput *ngIf="coverage.coverageType == 'Other'" [disabled]="mode == 'view'" shape="rectangle" [(ngModel)]="coverage.comment" (change)="element.errorMessage = null" 
                                    placeholder="Enter policy/coverage type" tPlaceholder="EnterPolicy/coverageType" i18n-placeholder="@@EnterPolicy/coverageType"/>
                            </div>
                        </ng-container>
                        <tsl-error *ngIf="element.errorMessage && element.errorMessage?.trim() != ''" >
                            {{ translate.get(element.errorMessage) }}
                        </tsl-error>
                        <button *ngIf="mode != 'view'" class="add-policy-button" tsl-button size="small" color="black" appearance="ghost" (click)="onAddCoverageRow(element)">
                            <tsl-icon>add</tsl-icon>
                            <span i18n="@@Policy/CoverageType" t="Policy/CoverageType">Policy/Coverage Type</span>
                        </button>
                    </div>
                </td>
            </ng-container>
        
            <ng-container matColumnDef="expirationDate">
                <th class="table-header-container" mat-header-cell *matHeaderCellDef>
                    <div class="table-header" i18n="@@Policy/CoverageExpirationDate" t="Policy/CoverageExpirationDate">Policy/Coverage Expiration Date</div>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <div class="expire-date-list-container">
                        <ng-container *ngFor="let coverage of element.coverages; let j = index">
                            <div class="expire-date-container">
                                <tsl-datepicker singleSelection [selectYear]="true" [disabled]="mode == 'view'" [min]="minDate" shape="rectangle" [(ngModel)]="coverage.expiryDate" (dateChange)="element.errorMessage = null" 
                                    placeholder="Select Date" tPlaceholder="SelectDate" i18n-placeholder="@@SelectDate" [readonly]="true"></tsl-datepicker>
                                <button *ngIf="mode != 'view' && element.coverages.length > 1" class="table-icon-button" tsl-icon-button size="small" (click)="onDeleteCoverageRow(element, j)">
                                    <span class="material-icons clear-drag-input-icon table-button-icon">clear</span>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="document">
                <th class="table-header-container" mat-header-cell *matHeaderCellDef>
                    <div class="table-header" i18n="@@Document" t="Document">Document</div>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="file-upload-container">
                        <div *ngIf="!element.document">
                            <input type="file" class="file-input" (change)="uploadFile($event, element)" #fileUpload>
                            <button [disabled]="mode == 'view'" tsl-button color="blue" filled size="small" shape="rectangle" (click)="fileUpload.click()" i18n="@@UploadFile" t="UploadFile">UPLOAD FILE</button>
                        </div>
                        <a *ngIf="element.document" class="file-name" (click)="downloadFile(element.document)">{{ element.document?.FileName }}</a>
                        <button *ngIf="element.document && mode != 'view'" class="table-icon-button" [hidden]="false" tsl-icon-button size="small" (click)="onDeleteFile(element)">
                            <span class="material-icons clear-drag-input-icon table-button-icon">delete</span>
                        </button>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th class="table-header-container" mat-header-cell *matHeaderCellDef>
                    <div class="table-header" i18n="@@Action" t="Action">Action</div>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <button *ngIf="mode != 'view' && (displayList?.length > 1 || !isRequired)" class="table-icon-button" tsl-icon-button size="small" (click)="onDeleteRow(i)">
                        <span class="material-icons clear-drag-input-icon table-button-icon">clear</span>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <tsl-error class="document-error-message" *ngIf="errorMessage">{{ translate.get(errorMessage) }}</tsl-error>
    <button *ngIf="mode != 'view'" class="add-document-button" tsl-button size="large" color="black" appearance="ghost" (click)="onAddRow()">
        <tsl-icon>add_circle_outline</tsl-icon>
        <span i18n="@@6479858202193175606" t="6479858202193175606">Add Document</span>
    </button>
</div>